import * as React from "react"
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next"
import { ChevronRight } from "@mui/icons-material"
import { Container } from "react-bootstrap"

export const Information: React.FC = () => {
  const { t } = useTranslation("translations", { keyPrefix: "INDEX" })

  return (
    <Container>
      <article className="my-5 text-center">
        <h1 className="mb-0">INFORMATION</h1>
        <small>{t("INFORMATION.SUBTITLE")}</small>
        <div className="mt-4 row">
          <div className="col-md-6 mb-3">
            <Link to="/articles/202004300900_share_transfer" className="d-block h-100 mx-md-2 mx-lg-5 text-start bg-light rounded cursor-pointer animation-on-cursor" style={{textDecoration: "none"}}>
              <div className="p-4 d-flex align-items-center">
                <ChevronRight className="me-3" />
                <div>
                  <small>2020.04.30</small>
                  <p className="m-0">株式譲渡のお知らせ</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-md-6 mb-3">
            <Link to="/articles/20200314100000_excelout" className="d-block h-100 mx-md-2 mx-lg-5 text-start bg-light rounded cursor-pointer animation-on-cursor" style={{textDecoration: "none"}}>
              <div className="p-4 d-flex align-items-center">
                <ChevronRight className="me-3" />
                <div>
                  <small>2020.03.14</small>
                  <p className="m-0">新製品「excelout」販売開始のお知らせ</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-md-6 mb-3">
            <Link to="/articles/20200314090000_new" className="d-block h-100 mx-md-2 mx-lg-5 text-start bg-light rounded cursor-pointer animation-on-cursor" style={{textDecoration: "none"}}>
              <div className="p-4 d-flex align-items-center">
                <ChevronRight className="me-3" />
                <div>
                  <small>2020.03.14</small>
                  <p className="m-0">ホームページリニューアルのお知らせ</p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </article>
    </Container>
  )
}
